import { DateTime } from "luxon";

export const checkIfStringIsDate = (dateString) => {
	return DateTime.fromISO(dateString).isValid;
};
export const isDiscountWithVoucher = (discount) => {
	return discount && Array.isArray(discount.voucherPattern) && discount.voucherPattern.length > 0;
};
